/**
 * Card 27 (Daniel ruling 2026-08-01): the referral question, answered at
 * creation — either a partner organization, or an explicit "None / direct".
 * Required wherever staff create a CRM contact (AddContactModal,
 * VoiceIntakeModal). The server refuses creation without it
 * (REFERRAL_ANSWER_REQUIRED) and migration 161's trigger backstops the server.
 *
 * Partner names load from alliance_partner:orgs:options (id + name of ACTIVE
 * orgs only — minimal disclosure, gated crm:create). If the list fails to
 * load, "None / direct" remains selectable and partner selection shows a
 * retry — the question never becomes skippable, and a load failure never
 * silently converts a partner referral into "none".
 */
import React, { useEffect, useState, useCallback } from 'react';

export default function ReferralAnswerField({ answer, partnerId, onChange }) {
  const [orgs, setOrgs] = useState(null);   // null = loading, [] = loaded-empty
  const [loadError, setLoadError] = useState(false);

  const load = useCallback(async () => {
    setLoadError(false);
    try {
      const rows = await window.zignagenixAPI.invoke('alliance_partner:orgs:options');
      setOrgs(Array.isArray(rows) ? rows : []);
    } catch (_) {
      setOrgs([]);
      setLoadError(true);
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  const label = { fontSize: 11, fontWeight: 600, color: '#6C757D', display: 'block', marginBottom: 3 };
  const inp = { width: '100%', padding: '7px 9px', border: '1px solid #DEE2E6', borderRadius: 7, fontSize: 13, background: '#fff' };

  return (
    <>
      <div>
        <label style={label}>Referred by a partner? *</label>
        <select
          value={answer}
          onChange={(e) => onChange({ answer: e.target.value, partnerId: e.target.value === 'partner' ? partnerId : '' })}
          required
          style={inp}
        >
          <option value="">— answer required —</option>
          <option value="none">None / direct</option>
          <option value="partner">Partner referral</option>
        </select>
      </div>
      {answer === 'partner' && (
        <div>
          <label style={label}>Partner organization *</label>
          {loadError ? (
            <button type="button" onClick={load} style={{ ...inp, textAlign: 'left', cursor: 'pointer' }}>
              Partner list failed to load — click to retry
            </button>
          ) : (
            <select
              value={partnerId}
              onChange={(e) => onChange({ answer, partnerId: e.target.value })}
              required
              style={inp}
            >
              <option value="">— select partner —</option>
              {(orgs || []).map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}
            </select>
          )}
        </div>
      )}
    </>
  );
}
